// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root[data-v-7de8fec6] .v-application--wrap{min-height:inherit}.v-banner[data-v-7de8fec6]{background-color:#ebeff5 !important;border:1px solid #d8d8da !important;color:#283b8a !important;text-color:#283b8a !important}", ""]);
// Exports
module.exports = exports;
